export const timeDisplay = {

    data() {
        return {
            dateFormats: [
                {
                    example: '2018-12-31 (ISO 8601)',
                    format: 'YYYY-MM-DD',
                },
                {
                    example: '31.12.2018 (Europe & Asia)',
                    format: 'DD.MM.YYYY',
                },
                {
                    example: '12/31/2018 (USA and Canada)',
                    format: 'MM/DD/YYYY',
                },
            ],

            timeFormats: [
                {
                    example: 'AM/PM',
                    format: '12h',
                },
                {
                    example: '24 hours',
                    format: '24h',
                },
            ]
        }
    },

    methods: {

        isBrowserLocale24h() {
            return !new Intl.DateTimeFormat(undefined, {hour: 'numeric'}).format(0).match(/\s/);
        },

        /**
         * Convert UTC datetime to local Human time i.e. in 24 hours
         *
         * @param dataTimeString
         * @param failPastTime Return false for past events
         * @return string
         */

        toHumanTill(dataTimeString, failPastTime) {

            if (failPastTime && moment.utc(dataTimeString).isBefore(moment.utc())) return false;

            return moment.utc(dataTimeString).local().fromNow();
        },

        /**
         * Convert UTC datetime to local human time i.e. 24 hours ago
         *
         * @param dateTimeString
         * @param failFutureTime Return false for past events
         * @returns {*}
         */
        toHumanFrom(dateTimeString, failFutureTime) {

            if (failFutureTime && moment.utc(dateTimeString).isAfter(moment.utc())) return false;
            return moment.utc(dateTimeString).local().fromNow();
        },

        /**
         * Format date time to user (browser) locale
         *
         * @returns {string}
         * @param dateTimeString
         */
        formatDateTime(dateTimeString) {
            const dateTime = moment(dateTimeString).toDate();
            return dateTime.toLocaleDateString() + ' ' + dateTime.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' });
        },

        /**
         * Convert UTC datetime to local timezone and localized format
         *
         * @returns {string}
         * @param dateString
         */

        toLocalDateTime(dateString) {
            const dateTime = moment.utc(dateString).local().toDate();
            return dateTime.toLocaleDateString() + ' ' + dateTime.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' });
        },

        /**
         * Format date to user (browser) locale
         *
         * @returns {string}
         * @param dateTimeString
         */

        formatDate(dateTimeString) {
            return moment(dateTimeString).toDate().toLocaleDateString();
        },

        /**
         * Format time without any conversion using format detected from the browser
         *
         * @param dateTimeString
         * @returns {string}
         */

        formatTime(dateTimeString) {
            return moment(dateTimeString).toDate().toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' });
        },

        /**
         * Convert UTC date to local timezone and date format
         *
         * @returns {string}
         * @param dateString
         */

        toLocalDate(dateString) {
            return moment.utc(dateString).local().toDate().toLocaleDateString();
        },

        /**
         * Convert UTC time to local timezone and time format
         *
         * @param dateString
         * @returns {string}
         */

        toLocalTime(dateString) {
            return moment.utc(dateString).local().toDate().toLocaleTimeString([],{ hour: '2-digit', minute: '2-digit' });
        },

        /**
         * Convert local time back to UTC time date
         *
         * @returns {*}
         * @param dateTimeString
         */

        toUTC(dateTimeString) {
            return moment(dateTimeString).utc().format('YYYY-MM-DD HH:mm:ss');
        },

        /**
         * Convert local date back to UTC time date
         *
         * @param dateString
         * @returns {*}
         */

        toUTCDate(dateString) {
            return moment(dateString).utc().format('YYYY-MM-DD');
        },

        /**
         * Check any date and return how old the date is
         *
         * @param dateString
         * @returns {number}
         */
        toDays(dateString) {
            //return moment.utc(dateString).local().diff(moment.utc(), 'days');
            return moment.utc().diff(moment.utc(dateString), 'days');
        },

        /**
         * Convert UTC date to local timezone and date format with month name
         *
         * @returns {*}
         * @param dateTimeString
         */

        withMonthNameLocale(dateTimeString) {
            return moment(dateTimeString).utc().format('LL');
        }
    },
};

